import { render } from "./CardForm.vue?vue&type=template&id=8d2971a8&scoped=true"
import script from "./CardForm.vue?vue&type=script&lang=ts"
export * from "./CardForm.vue?vue&type=script&lang=ts"

import "./CardForm.vue?vue&type=style&index=0&id=8d2971a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d2971a8"

export default script